import { effect, Injectable, signal } from "@angular/core";

export type SettingOption={
  messageShare: boolean;
  cardInfo: boolean;
  favorisInfo: boolean;
};

const DEFAULT_OPTIONS: SettingOption={
  messageShare: true,
  cardInfo: true,
  favorisInfo: false
};

@Injectable({ providedIn: "root" })
export class SettingService{
  private readonly _settings=signal<SettingOption>(this.load());
  readonly options=this._settings.asReadonly();

  constructor(){
    effect(() => {
      localStorage.setItem("settings", JSON.stringify(this._settings()));
    });
  }

  /** Setter générique typé */
  set<K extends keyof SettingOption>(key: K, value: SettingOption[K]){
    this._settings.update(s => ({...s, [key]: value}));
  }

  /** Patch générique */
  patch(patch: Partial<SettingOption>){
    this._settings.update(s => ({...s, ...patch}));
  }

  /** Bonus pratique pour les booléens */
  toggle<K extends keyof SettingOption>(key: K) {
    this._settings.update(s => ({...s, [key]: !Boolean(s[key])} as SettingOption));
  }

  private load(){
    const raw=localStorage.getItem("settings");
    if(!raw)
    	return {...DEFAULT_OPTIONS};

    try{
      const parsed=JSON.parse(raw) as Partial<SettingOption>;
      return {...DEFAULT_OPTIONS, ...parsed};
    }catch{
      return {...DEFAULT_OPTIONS};
    }
  }
}
